import moment from 'moment';

export const orderDetailInfoAdapter = (data) => {
	return [
		{
			key: data?.tracking?.[0]?._id,
			trx_id: data?.tracking?.[0]?.trx_id || '-',
			ruta: data?.tracking?.[0].pos?.data?.datos_entrega?.ruta || '-',
			createdAt: moment.unix(data?.tracking?.[0].createdAt).format('DD/MM/YYYY HH:mm:ss A') || '-',
			operation_id: data?.order?.[0].payment_gateway_info?.data?.operation_id || '-',
			schedule_selected:
				data?.order?.[0]?.info?.pharmacy?.[0]?.schedule_selected ||
				data?.order?.[0]?.info?.info_delivery?.date_schedule_narma ||
				'-',
			short_code: data?.quotation_short_code || '-',
			quotation_id: data?.quotation_id || '-',
			tracking_id: data?.tracking_id || '-',
			purchase_id: data?.purchase_id || '-',
		},
	];
};
